import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { mergeStyles, validate, containsUrl, normalizeUrl, GlobalContext } from 'wix-rich-content-common';
import pluginHtmlSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-html.schema.json';

const SRC_TYPE_HTML = "html";
const SRC_TYPE_URL = "url";
const INIT_WIDTH = 350;
const INIT_HEIGHT = 550;
const DEFAULTS_VIEWER = {};

var htmlIframeSrc = `
  <head>
    <style type="text/css">
      iframe[class|='instagram'],
      blockquote[class|='instagram'] {
        /* fallback script for ios below */
        min-width: 0 !important;
        width: calc(100vw - 2px);
      }

      body {
        margin: 0;
        max-width: calc(100vw);
        display: inline-block;
        float: left;
        width: 100%;
        box-sizing: border-box;
      }
      body > iframe {
        margin: 0 !important;
        width: calc(100vw - 2px) !important;
      }
      body::before,
      body::after {
        content: '.';
        height: 0;
        margin: 0;
        overflow: hidden;
        visibility: hidden;
        display: block;
        clear: both;
      }
    </style>
    <script>
      (function fixInstagramWidth() {
        // This is a fallback for the styles above. Because inline styles can't be overridden in ios.
        var callback = function() {
          try {
            if (document.body.firstChild.className.indexOf('instagram') >= 0) {
              document.body.firstChild.style.minWidth = '0';
              document.body.firstChild.style.width = 'calc(100vw - 2px)';
            }
          } catch (e) {}
        };

        var observer = new MutationObserver(callback);

        observer.observe(document, {
          childList: true,
          subtree: true,
        });
      })();

      function initSendHeight(id) {
        /**
         * Handle image load by triggering a resize
         */
        function imageLoaded(event) {
          if (!event || event.type !== 'load') {
            return;
          }

          var img = event.srcElement;
          // Remove image from loading stack
          var imageIndex = images.indexOf(img);
          if (imageIndex !== -1) {
            images.splice(imageIndex, 1);
          }

          handleResize();
        }

        /**
         * Add 'load' event listener and store reference to image
         * @param {elm} img Image being loaded
         */
        var images = [];
        function addImage(img) {
          if (images.indexOf(img) === -1) {
            img.addEventListener('load', imageLoaded);
            images.push(img);
          }
        }

        /**
         * Filter out images in the DOM that haven't loaded yet and add listener
         */
        function addImageLoadListeners() {
          var imgs = document.querySelectorAll('img');
          for (var i = 0; i < imgs.length; i++) {
            var image = imgs[i];
            // Do nothing if image is already loaded
            if (
              image.nodeName === 'IMG' &&
              image.src &&
              image.complete === false &&
              image.readyState !== 4
            ) {
              addImage(image);
            }
          }
        }

        function getHeight() {
          var offsetHeight = parseInt(document.body.offsetHeight, 10);
          var scrollHeight = parseInt(document.body.scrollHeight, 10);
          var height = Math.max(offsetHeight, scrollHeight);
          var styles = document.defaultView.getComputedStyle(document.body);
          height += parseInt(styles.getPropertyValue('margin-bottom'), 10);
          height += parseInt(styles.getPropertyValue('margin-top'), 10);
          return height;
        }

        function handleResize() {
          multipleDelayedSendHeight();
        }

        var timerId;
        function multipleDelayedSendHeight() {
          sendHeight();
          clearTimeout(timerId);
          let delay = 100;
          timerId = setTimeout(function request() {
            sendHeight();
            delay *= 2;
            if (delay < 20000) {
              timerId = setTimeout(request, delay);
            }
          }, delay);
        }

        function sendHeight() {
          var height = getHeight();
          parent.postMessage({ type: 'htmlPlugin:heightResize', id: id, height: height }, '*');
        }

        function setupMutationObserver() {
          var target = document.querySelector('body');
          var observer = new MutationObserver(function(mutations) {
            addImageLoadListeners();
            handleResize();
          });

          var config = {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true,
          };

          observer.observe(target, config);
        }

        window.addEventListener('resize', handleResize); //this handles width change
        setupMutationObserver();
        handleResize();
      }

      window.addEventListener('message', function(event) {
        if (event.data.type !== 'htmlPlugin:updateContent') {
          return;
        }

        var content = [
          '<!DOCTYPE html>',
          '<html>',
          '<head>' + document.head.innerHTML + '</head>',
          '<body>' + event.data.content + '</body>',
          '</html>',
        ].join('');

        document.open('text/html', 'replace');
        document.write(content);
        document.close();
        initSendHeight(event.data.id);
      });
    <\/script>
  </head>

  <body></body>
`;

var styles = {"iframe":"fb3YU"};

var __defProp$5 = Object.defineProperty;
var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$4 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$4.call(b, prop))
      __defNormalProp$5(a, prop, b[prop]);
  if (__getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(b)) {
      if (__propIsEnum$4.call(b, prop))
        __defNormalProp$5(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$4)
    for (var prop of __getOwnPropSymbols$4(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Iframe = (_a) => {
  var _b = _a, {
    iframeRef,
    isViewer
  } = _b, otherProps = __objRest(_b, [
    "iframeRef",
    "isViewer"
  ]);
  return /* @__PURE__ */ React.createElement(
    "iframe",
    __spreadValues$4({
      ref: iframeRef,
      className: styles.iframe,
      title: "remote content",
      style: { backgroundColor: "transparent" },
      allow: isViewer ? "fullscreen; autoplay" : "fullscreen",
      allowFullScreen: true
    }, otherProps)
  );
};

var __defProp$4 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$4(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$4(a, prop, b[prop]);
    }
  return a;
};
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$4(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const isSSR = typeof window === "undefined";
const HtmlSrcPath = "/html/2b2e4b_d767b483cae16e027c4ea8ac7906fbf4.html";
class IframeHtml extends Component {
  constructor() {
    super(...arguments);
    __publicField$1(this, "state", { shouldRender: false });
    __publicField$1(this, "id", Math.random().toString(36).substr(2, 9));
    __publicField$1(this, "updateIframeContent", (content) => {
      var _a;
      this.shouldIgnoreLoad = true;
      (_a = this.iframe) == null ? void 0 : _a.contentWindow.postMessage(
        { type: "htmlPlugin:updateContent", id: this.id, content },
        "*"
      );
    });
    __publicField$1(this, "handleIframeMessage", ({ data }) => {
      const { type, id, height } = data;
      if (type === "htmlPlugin:heightResize" && id === this.id) {
        this.props.onHeightChange(height);
      }
    });
    __publicField$1(this, "handleIframeLoad", () => {
      !this.shouldIgnoreLoad && this.updateIframeContent(this.props.html);
    });
  }
  componentDidMount() {
    this.setState({ shouldRender: true });
    !isSSR && window.addEventListener("message", this.handleIframeMessage);
  }
  componentWillUnmount() {
    !isSSR && window.removeEventListener("message", this.handleIframeMessage);
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.html !== nextProps.html) {
      this.updateIframeContent(nextProps.html);
    }
  }
  render() {
    const { iframeSandboxDomain, isViewer } = this.props;
    const iframeProps = {
      style: { backgroundColor: "transparent" },
      onLoad: this.handleIframeLoad,
      iframeRef: (iframe) => this.iframe = iframe,
      isViewer
    };
    if (iframeSandboxDomain) {
      const strippedUrl = iframeSandboxDomain.replace(/\/$/, "");
      iframeProps.src = strippedUrl + HtmlSrcPath;
    } else {
      iframeProps.srcdoc = htmlIframeSrc;
    }
    return this.state.shouldRender ? /* @__PURE__ */ React.createElement(Iframe, __spreadValues$3({}, iframeProps)) : null;
  }
}
IframeHtml.propTypes = {
  html: PropTypes.string.isRequired,
  onHeightChange: PropTypes.any,
  iframeSandboxDomain: PropTypes.string,
  isViewer: PropTypes.bool
};
var IframeHtml$1 = IframeHtml;

var __defProp$3 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const IframeUrl = (props) => /* @__PURE__ */ React.createElement(
  Iframe,
  __spreadProps(__spreadValues$2({}, props), {
    sandbox: "allow-popups allow-presentation allow-forms allow-same-origin allow-scripts"
  })
);

var htmlComponentStyles = {"htmlComponent":"zpZXa","htmlComponent_placeholder":"r6JF0"};

const htmlFixer = (html, pageURL) => {
  const isGoogleAds = html == null ? void 0 : html.includes("adsbygoogle");
  const isIncludePageUrl = html == null ? void 0 : html.includes("data-page-url=");
  if (pageURL && isGoogleAds && !isIncludePageUrl) {
    const updatedAd = `<ins class="adsbygoogle"
	data-page-url="${pageURL}"`;
    return html == null ? void 0 : html.replace(new RegExp('<ins class="adsbygoogle"', "g"), updatedAd);
  }
  return html;
};

var __defProp$2 = Object.defineProperty;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const getPageURL = (siteDomain) => {
  if (!siteDomain) {
    return;
  }
  const regex = /http.+com/gm;
  const res = regex.exec(siteDomain);
  if (res) {
    return res[0];
  }
  return res;
};
class HtmlComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      siteDomain: void 0
    });
    __publicField(this, "setHeight", (iframeHeight) => {
      var _a;
      if (iframeHeight > 0 && iframeHeight !== this.state.iframeHeight) {
        this.setState({ iframeHeight });
        (_a = this.props.store) == null ? void 0 : _a.update("componentData", { config: { height: iframeHeight } });
      }
    });
    __publicField(this, "getIframeHeight", () => {
      const {
        settings: { height } = {},
        componentData: { config }
      } = this.props;
      const { iframeHeight } = this.state;
      const maxDiff = Math.min(50, this.state.iframeHeight * 0.1);
      let normalizedHeight = iframeHeight;
      if (config.height) {
        normalizedHeight = iframeHeight && config.height < iframeHeight && config.height + maxDiff > iframeHeight ? iframeHeight : config.height;
      }
      return normalizedHeight || height || INIT_HEIGHT;
    });
  }
  componentDidMount() {
    const {
      componentData: { config },
      settings = {}
    } = this.props;
    const { width, height, siteDomain } = settings;
    if (!config.width) {
      if (width) {
        config.width = width;
      } else if (this.element) {
        config.width = this.element.getBoundingClientRect().width;
      } else {
        config.width = INIT_WIDTH;
      }
    }
    if (!config.height) {
      config.height = height || INIT_HEIGHT;
    }
    this.setState({ siteDomain });
  }
  static getDerivedStateFromProps(props, state) {
    const { componentData } = props;
    if (componentData.srcType === "html") {
      const pageURL = getPageURL(state.siteDomain);
      return {
        html: htmlFixer(componentData.src, pageURL)
      };
    }
  }
  render() {
    var _a;
    const { html } = this.state;
    const {
      iframeSandboxDomain,
      theme,
      componentData,
      settings: { width } = {},
      isViewer
    } = this.props;
    this.styles = this.styles || mergeStyles({ styles: htmlComponentStyles, theme });
    validate(componentData, pluginHtmlSchema);
    const { src, srcType, config: { width: currentWidth } = {} } = componentData;
    const style = {
      width: this.props.isMobile ? "auto" : currentWidth || width || INIT_WIDTH,
      height: this.getIframeHeight(),
      maxHeight: this.state.iframeHeight
    };
    const experiments = this.props.experiments || this.context.experiments;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: this.styles.htmlComponent,
        ref: (ref) => this.element = ref,
        style,
        "data-hook": "HtmlComponent"
      },
      srcType === SRC_TYPE_HTML && src && /* @__PURE__ */ React.createElement(
        IframeHtml$1,
        {
          iframeSandboxDomain: iframeSandboxDomain || ((_a = experiments.forceIframeSandboxDomain) == null ? void 0 : _a.enabled) && "https://www.filesusr.com",
          key: SRC_TYPE_HTML,
          tabIndex: 0,
          html,
          onHeightChange: this.setHeight,
          isViewer
        }
      ),
      srcType === SRC_TYPE_URL && containsUrl(src) && /* @__PURE__ */ React.createElement(IframeUrl, { key: SRC_TYPE_URL, tabIndex: 0, src: normalizeUrl(src), isViewer }),
      !src && !containsUrl(src) && /* @__PURE__ */ React.createElement("div", { className: this.styles.htmlComponent_placeholder })
    );
  }
}
__publicField(HtmlComponent, "contextType", GlobalContext);
HtmlComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  blockProps: PropTypes.object,
  className: PropTypes.string,
  settings: PropTypes.shape({
    width: PropTypes.number,
    minWidth: PropTypes.number,
    maxWidth: PropTypes.number,
    height: PropTypes.number,
    minHeight: PropTypes.number,
    maxHeight: PropTypes.number
  }).isRequired,
  store: PropTypes.object,
  block: PropTypes.object,
  siteDomain: PropTypes.string,
  theme: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  iframeSandboxDomain: PropTypes.string,
  experiments: PropTypes.object,
  isViewer: PropTypes.bool
};
var HtmlComponent$1 = HtmlComponent;

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const HtmlViewer = (props) => /* @__PURE__ */ React.createElement(HtmlComponent$1, __spreadValues$1({ isViewer: true }, props));

const HTML_TYPE = "wix-draft-plugin-html";

const typeMapper = () => ({
  [HTML_TYPE]: { component: HtmlViewer }
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginHtml = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS_VIEWER), config),
    type: HTML_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { HTML_TYPE, typeMapper as htmlTypeMapper, pluginHtml };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-html/dist/es/styles.viewer.min.global.css'